import React from 'react'
import { useRecoilValue } from 'recoil'

import { Flex } from 'mailup-web-components'
import StyledIconFilterGroup from './IconFilterGroup'
import StyledIconTestGroup from './IconTestGroup'
import StyledIconAll from './IconAll'

import {
  RECIPIENTS_ALL,
  RECIPIENTS_GROUP_FILTER,
  RECIPIENTS_TEST_GROUP
} from 'Pages/EmailSendingWizard/const'

import { abTestState } from 'Pages/AbTestWizard/recoil/state/abtest'

const BoxResultIcon = () => {
  const { step2 } = useRecoilValue(abTestState)

  const getIcon = () => {
    if (step2.recipients === RECIPIENTS_GROUP_FILTER) {
      return <StyledIconFilterGroup />
    } else if (step2.recipients === RECIPIENTS_TEST_GROUP) {
      return <StyledIconTestGroup />
    } else if (step2.recipients === RECIPIENTS_ALL) {
      return <StyledIconAll />
    }
  }

  return <Flex flex='0 0 40px'>{getIcon()}</Flex>
}

export default BoxResultIcon
